import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchProducts } from '../utils/apiHelpers';
import type { Product } from '../utils/apiHelpers';
import FallbackImage from './FallbackImage';

interface SearchDropdownProps {
  query: string;
  onClose: () => void;
}

export default function SearchDropdown({ query, onClose }: SearchDropdownProps) {
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!query.trim()) {
      setProducts([]);
      return;
    }
    const t = setTimeout(() => {
      setLoading(true);
      fetchProducts({ search: query })
        .then((data) => setProducts((data || []).slice(0, 10)))
        .catch(() => setProducts([]))
        .finally(() => setLoading(false));
    }, 150);
    return () => clearTimeout(t);
  }, [query]);

  return (
    <div className="absolute top-full left-0 right-0 mt-1 bg-[var(--background)] border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg max-h-80 overflow-y-auto z-50">
      {loading ? (
        <div className="p-4 text-sm text-gray-500">Searching...</div>
      ) : products.length === 0 ? (
        <div className="p-4 text-sm text-gray-500">No results found</div>
      ) : (
        <ul className="py-2">
          {products.map((p) => (
            <li key={p.id}>
              <button
                type="button"
                onMouseDown={() => {
                  navigate(`/product/${p.id}`);
                  onClose();
                }}
                className="w-full flex items-center gap-3 px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-800 text-left"
              >
                <FallbackImage
                  src={p.product_image}
                  alt=""
                  className="w-12 h-12 object-cover rounded"
                />
                <div>
                  <p className="font-medium text-[var(--foreground)]">{p.name}</p>
                  <p className="text-sm text-gray-500">PKR {p.price}</p>
                </div>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
